import RequestAbstract from '../abstract';

export default class PayoutOrders extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/payout-orders';
    }
}
